import { setTheme } from "theme/default/setTheme";

export const setBorderRadius_5px = setTheme(({ theme }) => `border-radius: ${theme.borderRadius.border_radius_5px}`);
